<script setup>
import py from 'js-pinyin'
import { ElMessage,ElDatePicker, ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
const lang = useI18n().locale.value
function formatTime(time, format) {
  const o = {
    'M+': time.getMonth() + 1, // 月份
    'D+': time.getDate(), // 日
    'H+': time.getHours(), // 小时
    'h+': time.getHours() % 12, // 小时（12小时制）
    'm+': time.getMinutes(), // 分
    's+': time.getSeconds(), // 秒
    'q+': Math.floor((time.getMonth() + 3) / 3), // 季度
    'S': time.getMilliseconds() // 毫秒
  };

  // 替换年份
  format = format.replace(/(Y+)/g, (match, p1) => (time.getFullYear() + '').slice(4 - p1.length));

  // 替换其他格式
  for (const k in o) {
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(new RegExp(`(${k})`, 'g'), (match, p1) => (p1.length === 1) ? o[k] : ('00' + o[k]).slice(-2));
    }
  }
  return format;
}
const title = ref('1'); // 称谓
const name = ref(''); // 姓名
const phone = ref(''); // 电话
const email = ref(''); // 邮箱
const message = ref(''); // 留言
const type = ref([]); // 账户类型
const code = ref(''); // 验证码
const time = ref(formatTime(new Date(), 'YYYY-MM-DD HH:mm')); // 预约时间
const disabledDate = (date) => {
  // 获取今天是星期几（0表示周日，6表示周六）
  const today = new Date();
  const currentDay = today.getDay();
  const currentTimeStamp = today.getTime();

  // 禁止周六和周日
  const day = date.getDay();
  if (day === 0 || day === 6) {
    return true;
  }

  // 禁止所有已经过去的日期
  if (date.getTime() < currentTimeStamp) {
    return true;
  }

  // 如果不是周六周日，且不是过去的日期，则不禁用
  return false;
};

const isNotName = ref(false);
const isNotPhone = ref(false);
const isNotEmail = ref(false);
const isNotMessage = ref(false);
const isNotCode = ref(false);
const vType = ref('请选择账户类型');
const vName = ref('请输入您的姓名');
const vPhone = ref('请输入您的联系电话');
const vEmail = ref('请输入您的电子邮箱');
const vMessage = ref('请输入您的留言');
const vCode = ref('请输入验证码');
const codeImgUrl = ref('https://w1.fdzq.com/index.php?g=api&m=checkcode&a=index&length=4&font_size=20&width=150&height=42&use_noise=1&use_curve=0');
const No = ref('852');
const region = ref("HK");
const regionList = reactive([
  {
    chat: "",
    charList: [
      {
        No: "86",
        code: "CN",
        country: "中国",
        en_name: "China"
      },
      {
        No: "852",
        code: "HK",
        country: "中国香港",
        en_name: "Hong Kong"
      },
      {
        No: "853",
        code: "MO",
        country: "中国澳门",
        en_name: "Macau"
      },
      {
        No: "886",
        code: "TW",
        country: "中国台湾",
        en_name: "Taiwan"
      }
    ]
  }
]);
const Chat = ref('A');
const charList = ref([]);
const fromChar = ref([]);
const isregion = ref(false)

onMounted(() => {
  for (let i = 0; i < 26; i++) {
    fromChar.value.push(String.fromCharCode(65 + i));
  }
  getRegionListPost()
  if (lang === 'hk') {
    vType.value = vType.value;
    vName.value = vName.value;
    vPhone.value = vPhone.value;
    vEmail.value = vEmail.value;
    vMessage.value = vMessage.value;
    vCode.value = vCode.value;
    // ... 其他国际化处理
    document.title = vType.value;
  } else if (lang === 'en') {
    vType.value = 'Please enter your account type';
    vName.value = 'Please enter your name';
    vPhone.value = 'Please enter your contact number';
    vEmail.value = 'Please enter your email';
    vMessage.value = 'Please enter your message';
    vCode.value = 'Please enter the verification code';
    document.title = 'Forthright Securities';
  }
})

function regionClick(item) {
 No.value = item.No;
 region.value = item.code;
  isregion.value = false;
}

function refresh() {
  const randomDate = (new Date()).valueOf();
  codeImgUrl.value = `https://w1.fdzq.com/index.php?g=api&m=checkcode&a=index&length=4&font_size=20&width=150&height=42&use_noise=1&use_curve=0&_ref=${randomDate}`;
}

async function getRegionListPost  () {
  const res = await getRegionList()
  if (res.data.status == 0) {
      let zm = '';
      fromChar.value.forEach((ele, i) => {
        res.data.forEach((item, index) => {
          zm = lang === 'en' ? item.en_name.charAt(0) : py.getCamelChars(item.country).charAt(0);
          if (zm == ele) {
            if (ele == Chat.value) {
              charList.value.push(item);
            } else {
              regionList.value.push({
                chat: Chat.value,
                charList: charList.value
              });
              charList.value = [];
              Chat.value = ele;
              charList.value.push(item);
            }
          }
        });
      });
      regionList.value.push({
        chat: Chat.value,
        charList: charList.value
      });
    }
  // axios.get('https://apitrade.fdzq.com/user/login/get_region_list').then((res) => {
  //   res = res.data;

  // });
}

function changeValue() {
  if (name) {
    isNotName.value = false;
  }
  if (phone) {
    isNotPhone.value = false;
  }
  if (email) {
    isNotEmail.value = false;
  }
  if (message.value) {
    isNotMessage.value = false;
  }
  if (code) {
    isNotCode.value = false;
  }
}

async function sendMsg() {
  let errFlag = false,
    titleName = '', // 称谓
    accountName = []; // 账户类型

  // 校验输入

  // 判断账户类型是否为空
  if (type.value?.length <= 0 || !type.value) {
    ElMessage({
    message: vType,
    type: 'error',
  })

    return;
  }

  if (!name.value) {
    isNotName.value = true;
    errFlag = true;
  }
  if (!phone.value) {
    isNotPhone.value = true;
    errFlag = true;
  }
  if (!email.value) {
    isNotEmail.value = true;
    errFlag = true;
  }
  if (!message.value) {
    isNotMessage.value = true;
    errFlag = true;
  }
  if (!code.value) {
    isNotCode.value = true;
    errFlag = true;
  }

  if (errFlag) return;

  switch (title.value) {
    case '1':
      titleName = '先生';
      break;
    case '2':
      titleName = '小姐';
      break;
    case '3':
      titleName = '太太';
      break;
    default:
      titleName = '女士';
  }

  type.value?.forEach((item) => {
    let acName1 = '证券账户';
    let acName2 = '期货账户';
    if (item == 1) {
      accountName.push(acName1);
    } else if (item == 2) {
      accountName.push(acName2);
    }
  });

  // let hostname = location.hostname,
  //   url = 'https://w1.fdzq.com/Api/hk/appointment_open';
  // // 测试环境
  // if (
  //   hostname.indexOf('10.253') != -1 ||
  //   hostname.indexOf('192.168.') != -1 ||
  //   hostname.indexOf('dev-') != -1 ||
  //   hostname.indexOf('localhost') != -1
  // ) {
  //   url = 'https://dev2-www.fdzq.com/Api/hk/appointment_open';
  // }
  // 转fromData格式
  let formData = new FormData();
  formData.append('title', titleName);
  formData.append('name', name.value);
  formData.append('phone', phone.value.replaceAll(" ", ""));
  formData.append('email', email.value.replaceAll(" ", ""));
  formData.append('message', message.value);
  formData.append('region',region.value);
  formData.append('type', accountName.join(','));
  formData.append('time', `${time.value}:00`);
  formData.append('code', code.value);

  const res = await getAppointment(formData)
  if (res.status == 0) {
    ElMessage({
      message: lang === 'en' ? 'Sent successfully' : lang === 'hk' ? '提交成功' : '提交成功',
      type: 'success',
    })
    title.value = 1;
    name.value = '';
    email.value = '';
    phone.value = '';
    message.value = '';
    time.value = formatTime(new Date(), 'YYYY-MM-DD HH:mm');
    type.value = [];
    code.value = '';
    refresh();
  } else {
    ElMessage({
    message: res.message,
    type: 'error',
  })
  }

}
</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24>
      <div class="reservation-page">
    <div class="about-warp__right--title" v-if="lang !== 'en'">{{ $t('yykh') }}</div>
    <div class="about-warp__right--title" v-else>Make an appointment for account opening in HK</div>
    <div class="about-warp__right--content reservation-box">
      <div class="reservation-title">{{ $t('qwztxxlzlwmhjkynlx') }}</div>
      <div class="reservation-form">
        <div class="account-type">
          <em class="star-red">*</em>{{ $t('zhlx') }}&nbsp;&nbsp;&nbsp;
          <label>
            <input type="checkbox" class="account-radio" name="account" value="1" v-model="type">
            <i></i>{{ $t('zqzh') }}
          </label>
          <label>
            <input type="checkbox" class="account-radio" name="account" value="2" v-model="type">
            <i></i>{{ $t('qhzh') }}
          </label>
        </div>
        <div class="salutation">
          <em class="star-red">*</em>{{ $t('cw') }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <label>
            <input type="radio" class="radio" name="salutation" value="1" v-model="title">
            <i></i>{{ $t('xs') }}
          </label>
          <label>
            <input type="radio" class="radio" name="salutation" value="4" v-model="title">
            <i></i>{{ $t('ns') }}
          </label>
        </div>
        <p>
          <em class="star-red">*</em>{{ $t('xm') }}
        </p>
        <input
          type="text"
          class="input"
          name
          id="name"
          :placeholder="vName"
          autofocus="autofocus"
          v-model="name"
          @input="changeValue"
        >
        <div class="tips" v-show="isNotName">{{ $t('xmbnwkqzxsr') }}</div>
        <p>
          <em class="star-red">*</em>{{ $t('lxdh') }}
        </p>
         <div class="phone">
          <div class="region" :class="{'region2':No.length==3}">
            <span  @click="isregion=!isregion">+{{No}}</span>
            <ul class="regionList" v-show="isregion">
              <li v-for="(item,index) in regionList" :key="index">
                <ul>
                  <li v-if="item.chat">{{item.chat}}</li>
                  <li @click.stop="regionClick(ele)" :class="{'active':ele.No==No}" v-for="(ele,i) in item.charList" :key="i">+{{ele.No}}<span>{{lang === 'en'?ele.en_name:ele.country}}</span></li>
                </ul>
              </li>
            </ul>
          </div>
          <input type="text" class="input" name="" id="tel" :placeholder="vPhone" v-model.trim="phone" @input="changeValue"/>
        </div>
        <div class="tips" v-show="isNotPhone">{{ $t('lxdhbnwkqzxsr') }}</div>
        <p>
          <em class="star-red">*</em>{{ $t('dzyx') }}
        </p>
        <input
          type="text"
          class="input"
          name
          id="mail"
          :placeholder="vEmail"
          v-model.trim="email"
          @input="changeValue"
        >
        <div class="tips" v-show="isNotEmail">{{ $t('dzyxbnwkqzxsr') }}</div>
        <div class="date-time" style="margin-bottom: 0;">
          <em class="star-red">*</em>{{ $t('yyrqhsj') }}&nbsp;&nbsp;&nbsp;&nbsp;
          <el-config-provider :locale="zhCn">
            <el-date-picker

            style="display: block;"
            v-model="time"
            type="datetime"
            placeholder="选择日期时间"
            format="YYYY-MM-DD HH:mm"
            value-format="YYYY-MM-DD HH:mm"
            date-format="YYYY-MM-DD HH:mm"
            :disabled-date="disabledDate"

          >
          </el-date-picker>
          </el-config-provider>


        </div>
        <p>
          <em class="star-red">*</em>{{ $t('ly') }}
        </p>
        <textarea
          name
          class="input message"
          :placeholder="vMessage"
          id="idea"
          v-model="message"
          @input="changeValue"
        ></textarea>
        <div class="tips" v-show="isNotMessage">{{ $t('lybnwkqzxsr') }}</div>
        <p>
          <em class="star-red">*</em>{{ $t('yzm') }}
        </p>
        <input
          type="text"
          class="input"
          name
          id="code"
          :placeholder="vCode"
          v-model="code"
          @input="changeValue"
        >
        <div class="code-img">
          <img :src="codeImgUrl" alt="" @click="refresh">
        </div>
        <div class="tips" v-show="isNotCode">{{ $t('yzmbnwkqzxsr') }}</div>
        <button class="btn-idea" @click="sendMsg">{{ $t('tj') }}</button>
      </div>
    </div>
     </div>


    </div>
  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";
@media screen and (max-width: 420px) {
  body {

    .reservation-page {

      background: #FFFFFF;
      .reservation-box {
        .reservation-title {
          height: auto;
        }
        .reservation-form {
          .account-type {
            label {
              margin: 5px 0;
            }
          }
          input[type='text'] {
            width: 100%;
          }

          textarea {
            width: 100%;
          }

          .btn-idea {
            display: block;
            float: none;
            margin: 20px auto;
          }
        }
      }
    }
  }
}

.reservation-page {

  .reservation-title {
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    color: #1D2228;
    margin-bottom: 30px;
  }

  .reservation-box {
    .reservation-form {
      input::-webkit-input-placeholder {
        color: #9B9B9B;
      }

      textarea::-webkit-input-placeholder {
        color: #9B9B9B;
      }

      vertical-align: top;
      //width: 380px;
      // padding-top: 20px;
      display: inline-block;

      .tips {
        font-size: 12px;
        color: #D43F38;
        line-height: 14px;
        padding-left: 22px;
        position: relative;
        top: -30px;
      }

      .tips-msg {
        top: 0;
      }

      .code-img {
        position: relative;
        right: 0;
        top: -67px;

        img {
          cursor: pointer;
          display: block;
          height: 30px;
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      .message {
        margin-bottom: 30px;
      }

      .date-time {
        height: 100px;
        margin-bottom: 30px;
        :deep(.el-input__wrapper) {
        border: 0;
        outline: 0;
        border-bottom: 2px solid #EFEFEF;
        font-size: 14px;
        width: 380px;
        padding: 7px 22px 7px 35px;
        margin-bottom: 34px;
        margin-top: 5px;
        opacity: 0.8;
        color: #06234E;
        padding-left: 21px;
        box-shadow: none !important;
        &:focus {
          border-color: #D43F38;
        }
        }

        // input{
        //   padding-left: 35px !important;
        // }
      }

      .el-input__prefix {
        height: 50px;
        //margin-right: 20px;
      }

      .el-input__icon {
        height: 50px;
      }

      .account-type {
        margin-bottom: 30px;

        label {
          cursor: pointer;
          display: inline-block;
          margin-right: 20px;
          .font-size-line(14, 20);
          vertical-align: middle;
          position: relative;

          &:last-child {
            margin-right: 0;
          }
        }

        input[type="checkbox"] {
          vertical-align: middle;
          margin-right: 2px;
          position: absolute;
          clip: rect(0, 0, 0, 0);
          & + i {
            display: inline-block;
            vertical-align: middle;
            width: 16px;
            height: 16px;
            // background-color: #f5f5f5;
            // border: 1px solid #e6e9ed;
            // border-radius: 50%;
            background: url('https://tg.fdzq.com/img/forthright-sec/images/about/icons/checkbox_unselected@2x.png') no-repeat center;
            background-size: 100% 100%;
            margin-right: 6px;
            padding: 5px 5px;
            position: relative;
            top: -1px;
          }
        }

        input[type="checkbox"]:checked {
          & + i {
            // border-color: #d54745;
            // background-color: #d54745;
            // background-clip: content-box;
            background: url('https://imgoss.fdzq.com/go_fd_co/fd-1652334465-tlb6g3.png') no-repeat center;
            background-size: 100% 100%;
          }
        }

      }

      .salutation {
        margin-bottom: 30px;
        label {
          cursor: pointer;
          display: inline-block;
          margin-right: 20px;
          .font-size-line(14, 20);
          vertical-align: middle;
          position: relative;

          &:last-child {
            margin-right: 0;
          }
        }
        input[type="radio"] {
          vertical-align: middle;
          margin-right: 2px;
          position: absolute;
          clip: rect(0, 0, 0, 0);

          & + i {
            display: inline-block;
            vertical-align: middle;
            width: 16px;
            height: 16px;
            background-color: #F5F5F5;
            border: 1px solid #E6E9ED;
            border-radius: 50%;
            margin-right: 6px;
            padding: 5px 5px;
            position: relative;
            top: -1px;
          }
        }
        input[type="radio"]:checked {
          & + i {
              // border-color: #D54745;
            background: url(https://imgoss.fdzq.com/go_fd_co/fd-1652254140-6qsg03.png);
            background-size:100%;
            background-color: none;
            border:none;
          }
        }
      }

      span {
        display: inline-block;
        text-indent: 0;
        margin-bottom: 3px;
        font-size: 14px;
        color: #06234E;
      }

      .star-red {
        opacity: 0.8;
        font-size: 14px;
        color: #D43F38;
        margin: 0 9px 0 8px;
      }

      input[type="text"] {
        border: 0;
        outline: 0;
        border-bottom: 2px solid #EFEFEF;
        font-size: 14px;
        width: 380px;
        padding: 7px 22px 7px 35px;
        margin-bottom: 34px;
        margin-top: 5px;
        opacity: 0.8;
        color: #06234E;
        padding-left: 21px;
        &:focus {
          border-color: #D43F38;
        }
      }

      textarea {
        font-size: 14px;
        border: 0;
        outline: 0;
        border-bottom: 2px solid #EFEFEF;
        width: 380px;
        padding: 7px 22px;
        // height: 120px;
        max-height: 120px;
        max-width: 380px;
        opacity: 0.8;
        color: #06234E;

        &:focus {
          border-color: #D43F38;
        }
      }
    }

    .btn-idea {
      margin-top: 30px;
      margin-bottom: 50px;
      float: right;
      cursor: pointer;
      background: #D43F38;
      border-radius: 3px;
      width: 180px;
      height: 48px;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 48px;
      text-align: center;
      border: 0;
      outline: 0;
      float: left;
      &:hover {
        background: #E74A43;
      }
    }
  }
  .phone{
    display: flex;
    position: relative;
    .region{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #D54745;
      line-height: 14px;
      position: absolute;
      top: 14px;
      left: 21px;
      cursor: pointer;
      span{
        color: #D54745;
        margin-left: 0px;
        position: absolute;
        padding-right: 15px;
        z-index: 9;
      }
      &::after{
        content: '';
        width: 10px;
        height: 5px;
        background: url('https://imgoss.fdzq.com/go_fd_co/fd-1652253756-xtu7ah.png') no-repeat;
        background-size: 100%;
        position: absolute;
        right: -40px;
        top: 4px;
        z-index: 9;
      }
      .regionList{
        width: 384px;
        max-height: 333px;
        background: #FFFFFF;
        border: 1px solid #F1F1F1;
        position: absolute;
        left: -24px;
        top: 21px;
        z-index: 1;
        padding-left: 22px;
        overflow-y: auto;
         &::-webkit-scrollbar{
          width: 8px;
          height: 16px;
          background-color: #fff;
        }
        &::-webkit-scrollbar-thumb{
          background: #BEC4CA;
          border-radius: 4px;
        }
        li{
          ul{
            li{
              border-bottom: 1px solid #F4F4F4;
              height: 38px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #868E95;
              line-height: 38px;
              display: flex;
              align-items: center;
              position: relative;
              span{
                color: #333333;
                position: absolute;
                left: 100px;
                top: 0;
                bottom: 0;
                margin: auto;
              }
            }
          }

        }
        .active{
          color: #D54745;
          span{
            color: #D54745;
          }
        }
      }
    }
    .region2{
        &::after{
           content: '';
            width: 10px;
            height: 5px;
            background: url('https://imgoss.fdzq.com/go_fd_co/fd-1652253756-xtu7ah.png') no-repeat;
            background-size: 100%;
            position: absolute;
            right: -48px;
            top: 4px;
        }
    }
    input{
      padding-left: 86px !important;
    }
  }
}
.el-date-picker__editor-wrap {
    position: relative;
    display: table-cell;
    padding: 0 5px;
}
.el-date-picker__time-header {
    position: relative;
    border-bottom: 1px solid #e4e4e4;
    font-size: 12px;
    padding: 8px 5px 5px 5px;
    display: table;
    width: 100%;
    box-sizing: border-box;
}
.el-date-picker__header {
    margin: 12px;
    text-align: center;
}
.el-date-picker__header-label {
    font-size: 14px;
    padding: 0 5px;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
}
.el-date-picker__header-label:hover {
    color: #DF4D47;
}
.el-date-picker__header-label.active {
    color: #DF4D47;
}
</style>
